import { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import NoneAnchor from 'components/NoneAnchor'
import { useDispatch } from 'react-redux'
import { setLnbOver } from 'features/lnb/lnbSlice'

export const MenuLink = ({ to, children, prefix, className = 'link_sub' }) => {
  const dispatch = useDispatch()
  const match = useRouteMatch(to)
  const { pathname } = useLocation()
  const history = useHistory()
  const isActive = prefix ? pathname.startsWith(prefix) : match
  return (
    <li className={classNames({ on: isActive })}>
      <NoneAnchor
        className={className}
        onClick={() => {
          dispatch(setLnbOver(false))
          history.push(to)
        }}>
        {children}
      </NoneAnchor>
    </li>
  )
}

MenuLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  className: PropTypes.string,
}

export const MenuGroup = ({ title, items }) => {
  const { pathname } = useLocation()
  const [active, setActive] = useState(false)
  const isChildrenMatch = useMemo(
    () =>
      items
        .map(item => item.prefix || item.to)
        .some(path => pathname.startsWith(path)),
    [items, pathname]
  )
  useEffect(() => {
    setActive(isChildrenMatch)
  }, [isChildrenMatch])
  return (
    <li
      className={classNames({
        open: active,
        on: isChildrenMatch,
      })}>
      <NoneAnchor
        className="link_snb"
        onClick={() => setActive(isActive => !isActive)}>
        {title}
        <span className="ico_gnb ico_arrow" />
      </NoneAnchor>
      <ul className="sub_snb">
        {items.map(({ to, prefix, title: menuTitle }) => (
          <MenuLink key={to} to={to} prefix={prefix}>
            {menuTitle}
          </MenuLink>
        ))}
      </ul>
    </li>
  )
}
MenuGroup.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      to: PropTypes.string.isRequired,
      prefix: PropTypes.string,
      title: PropTypes.node.isRequired,
    })
  ).isRequired,
  title: PropTypes.node.isRequired,
}
